import Table from '../../ui/Table';
import { microtaskTypeData } from '../bounties/microtasktypes/microtaskTypeData';

const TestMCQSD = ({ dataTask }) => {
    const titleObject = dataTask.task.find((obj) => Object.keys(obj).includes('Title'));
    const questionObject = dataTask.task.find((obj) => Object.keys(obj).includes('question'));
    const correctAnswerObject = dataTask.task.find((obj) => Object.keys(obj).includes('correctAnswer'));
    const answersObject = dataTask.task.find((obj) => Object.keys(obj).includes('answers'))?.answers.split(',,');

    return (
        <Table.Row>
            <p className=" text-textPrimary flex flex-col   ">
                <span className="font-medium mb-1  "> {titleObject?.Title || '-'} </span>
                <span className="text-xs font-medium">{questionObject?.question || '-'}</span>
                <div className="mt-1">
                    {answersObject.map((answer, i) => (
                        <p key={answer + i} className=" text-textPrimary text-xs mb-1 ">
                            <span> {answer || '-'}</span>
                        </p>
                    ))}
                </div>
            </p>
            <p className="text-sm justify-self-center">
                {microtaskTypeData.find((ele) => ele.type === dataTask.actionType).label}
            </p>

            <div>
                <p className=" text-textPrimary mb-1 break-words ">
                    {dataTask?.submission?.answer?.[0] ? dataTask?.submission?.answer?.[0] : <span>Not answered</span>}
                </p>
            </div>
        </Table.Row>
    );
};

export default TestMCQSD;
